import { Route, Routes } from "react-router";
import Sites from "./Sites";
import AddSite from "./AddSite";
import SiteDetail from "./SiteDetail";
import SiteOnboarding from "./SiteOnboarding";

function SitesRoutes() {
  return (
    <Routes>
      <Route path="" element={<Sites />} />
      <Route path=":site">
        <Route path="" element={<SiteDetail />} />
        <Route path="onboarding" element={<SiteOnboarding />} />
      </Route>
      <Route path="add" element={<AddSite />} />
    </Routes>
  );
}

export default SitesRoutes;
